const body = qs('body')

/* Toggle Class (Generic) */
function toggleClass(modalName) {
	var modalActive = document.querySelector(modalName)
	modalActive.classList.toggle('active')
}

/* Change Product Quantity */
function changeQuantity(formId, quantity) {
	var formQ = document.querySelector(formId)

	if (quantity == '+') {
		Number(formQ.value++)
	} else if (quantity == '-' && formQ.value > 1) {
		Number(formQ.value--)
	}
}

/* Open Cart */
function cartOpen() {
	body.classList.toggle('js-my-cart-open')
	const cart = qs('#shopify-section-my-cart')

	if (body.classList.contains('js-my-cart-open')) {
		setTimeout(() => {
			cart.focus()
		}, 0)
	}
}

/* Details Animator */
const details = document.querySelectorAll('details')

if (details) {
	details.forEach((targetDetail) => {
		targetDetail.addEventListener('click', function (e) {
			if (targetDetail.hasAttribute('open')) {
				e.preventDefault()
				targetDetail.classList.add('closing')
				setTimeout(() => {
					targetDetail.removeAttribute('open')
					targetDetail.classList.remove('closing')
				}, 390)
			}
		})
	})
}

/* Orphan Remove and LSEP Removal */
// var nbspSelectors = [
// 	'h1',
// 	'h2',
// 	'h3',
// 	'h4',
// 	'h5',
// 	'h6',
// 	'p:not([data-orphan-ignore])',
// 	'span',
// ]
// var nbspWordMin = 10 //Minimum words within parent tag to activate script

// nbspSelectors.forEach(function (selector) {
// 	var nbspElements = document.querySelectorAll(selector)
// 	nbspElements.forEach(function (element) {
// 		element.innerHTML = element.innerHTML.replace(/\u2028/g, '')
// 		element.innerHTML = element.innerHTML.replace(/&#8232;/g, '')
// 		var wordCount = element.innerHTML.split(' ').length
// 		if (wordCount >= nbspWordMin) {
// 			element.innerHTML = element.innerHTML.replace(/ ([^ ]*)$/, '&nbsp;$1')
// 		}
// 	})
// })

/* Lazy Load Initialiser */
var lazyLoadInstance = new LazyLoad({})

/* Liquid Ajax Cart */

liquidAjaxCart.subscribeToCartAjaxRequests((state, subscribeToResult) => {
	if (state.requestType == 'add') {
		const form = state.info.initiator
		let btnInner = ''

		const btn = form.querySelector('button[type="submit"]')
		if (btn) {
			btnInner = btn.innerHTML
			btn.innerHTML = 'ADDING'
		}

		subscribeToResult((state, second) => {
			const btn = form.querySelector('button[type="submit"]')
			if (state.responseData.ok) {
				cartOpen()
			}

			if (btn) {
				setTimeout(() => {
					btn.innerHTML = btnInner
				}, 300)
			}
		})
	}
})

/* enterview */
/* Load video on enter */

const llVideos = document.querySelectorAll('video.lazy')

if (llVideos.length > 0) {
	enterView({
		selector: '.video-ll',
		enter: function (el) {
			el.load()
			el.play()
		},
		offset: 0.1
	})
}

//Toggle Cart Buttons
const cartBtns = qsa('[data-cart-btn]')

cartBtns.forEach((btn) => {
	btn.addEventListener('click', (e) => {
		e.preventDefault()
		cartOpen()
	})
})

const searchBtns = qsa('[data-search-btn]')
const searchBar = qs('#headerSearchbar')
const searchBarInput = qs('#headerSearchbarInput')
const header = qs('header')
const parentMenuItems = qsa('[data-level-menu]')
const navCategories = qsa('[data-link-category]')
const extendedNav = qs('#headerExtended')
const mo = qs('#headerExtended')
const triggerBtns = qsa('[data-mobile-nav-trigger]')
const hamburgerNavBtn = qs('#mobileHamburgerNavBtn')
const mobileNavBg = qs('#mobileNavBg')

searchBtns.forEach((btn) => {
	btn.addEventListener('click', () => {
		searchBar.classList.toggle('active')
		searchBarInput.focus()

		if (searchBar.classList.contains('active')) {
			searchBar.removeAttribute('aria-hidden')
			searchBar.removeAttribute('inert')
		} else {
			searchBar.setAttribute('aria-hidden', true)
			searchBar.setAttribute('inert', '')
		}
	})
})

parentMenuItems.forEach((item) => {
	item.addEventListener('mouseenter', () => {
		const cat = item.dataset.levelMenu
		const prev = qs('[data-link-category].active')
		const next = qs(`[data-link-category="${cat}"]`)

		extendedNav.classList.add('active')
		if (prev) {
			prev.classList.remove('active')
			prev.setAttribute('aria-hidden', true)
			prev.setAttribute('inert', '')
		}

		next.classList.add('active')
		next.removeAttribute('aria-hidden')
		next.removeAttribute('inert', '')
	})
})

header &&
	header.addEventListener('mouseleave', () => {
		const prev = qs('[data-link-category].active')
		extendedNav.classList.remove('active')
		extendedNav.removeAttribute('style')
		prev && prev.classList.remove('active')
		mobileNavBg.classList.remove('active')
		hamburgerNavBtn && hamburgerNavBtn.classList.remove('active')
	})

// Mobile Navigation

const mobileNavTitles = qsa('[data-mobile-nav-category]')

triggerBtns &&
	triggerBtns.forEach((btn) => {
		btn.addEventListener('click', () => {
			extendedNav.classList.toggle('active')
			hamburgerNavBtn.classList.toggle('active')
			mobileNavBg.classList.toggle('active')
			resetMobileNav()
			if (extendedNav.classList.contains('active')) {
				const height = navCategories[0].clientHeight
				const initialCategory = navCategories[0]

				initialCategory.classList.add('active')
				initialCategory.removeAttribute('inert')
				initialCategory.setAttribute('aria-hidden', false)

				extendedNav.style.height = `${height}px`
				mobileNavTitles[0].classList.add('active')
			} else {
				resetMobileNav()
				extendedNav.removeAttribute('style')
			}
		})
	})

mobileNavTitles.forEach((btn) => {
	btn.addEventListener('click', () => {
		const cat = btn.dataset.mobileNavCategory
		const next = qs(`[data-link-category="${cat}"]`)
		const height = next.clientHeight

		resetMobileNav()

		extendedNav.style.height = `${height}px`
		btn.classList.add('active')
		next.classList.add('active')
		next.removeAttribute('inert')
		next.setAttribute('aria-hidden', false)
	})
})

function resetMobileNav() {
	const prevTitle = qs('[data-mobile-nav-category].active')
	const prevCat = qs('[data-link-category].active')

	if (prevTitle) {
		prevTitle.classList.remove('active')
	}
	if (prevCat) {
		prevCat.classList.remove('active')
		prevCat.setAttribute('inert', '')
		prevCat.setAttribute('aria-hidden', true)
	}
}

/* EnterView  */

const reveals = document.querySelectorAll('.reveal')
const stagger = document.querySelectorAll('.stagger')

if (reveals.length > 0) {
	enterView({
		selector: '.reveal',
		enter: (el, i) => {
			el.classList.add('entered')
		},
		exit: (el) => {
			el.classList.remove('entered')
		},
		offset: 0.1
	})
}

// if (stagger.length > 0) {
// 	stagger.forEach((el) => {
// 		el.querySelectorAll('.stagger-child').forEach((e, i) => {
// 			e.style.setProperty('--animation-order', i + 1)
// 		})
// 	})
// }

const toggleCreditsBtns = qsa('[data-toggle-credits-btn]')
const credits = qs('#footerCredits')

toggleCreditsBtns.forEach((btn) => {
	btn.addEventListener('click', () => {
		credits.classList.toggle('active')
	})
})

credits &&
	credits.addEventListener('mouseleave', () => {
		credits.classList.remove('active')
	})

// Collection

const filterBtns = qsa('[data-filter-btn]')
const filters = qs('#collectionFilters')

filterBtns.forEach((btn) => {
	btn.addEventListener('click', () => {
		filters.classList.toggle('active')
	})
})

// ========== SWIPERS

//Product Swiper

var productSwiper = new Swiper('#productCarousel', {
	direction: 'horizontal',
	freeMode: {
		enabled: true,
		sticky: true
	},
	slidesPerView: 1,
	spaceBetween: 0,
	mousewheel: {
		forceToAxis: true,
		sensitivity: 0.6
	},

	pagination: {
		el: '.product__carousel-pagination'
	},

	breakpoints: {
		768: {
			direction: 'vertical',
			freeMode: {
				enabled: true,
				sticky: false
			},
			spaceBetween: 0,
			mouseWheel: {
				sensitivity: 0.3
			}
		}
	}
})

// Mobile Triple Image Swiper

const tripleImageSwipers = qsa('[data-mobile-triple-swiper]')

tripleImageSwipers.forEach((swiper, i) => {
	swiper.dataset.mobileTripleSwiper = i

	const _swiper = new Swiper(swiper, {
		direction: 'horizontal',

		slidesPerView: 1.5,
		spaceBetween: 8,
		mousewheel: {
			forceToAxis: true,
			sensitivity: 0.6
		}
	})
})

const detailsText = qsa('[data-detail-text]')
const detailsMedia = qsa('[data-detail-media]')
const productDetailsSwiper = qsa('[data-product-details-swiper]')

detailsText.forEach((text, i) => {
	text.addEventListener('mouseenter', () => {
		qs('[data-detail-text].active').classList.remove('active')
		qs('[data-detail-media].active').classList.remove('active')

		text.classList.add('active')
		detailsMedia[i].classList.add('active')
	})
})
detailsMedia.forEach((media, i) => {
	media.addEventListener('mouseenter', () => {
		qs('[data-detail-text].active').classList.remove('active')
		qs('[data-detail-media].active').classList.remove('active')

		media.classList.add('active')
		detailsText[i].classList.add('active')
	})
})

productDetailsSwiper.forEach((swiper, i) => {
	swiper.dataset.mobileTripleSwiper = i

	detailsText.forEach((text, i) => {
		text.addEventListener('click', () => {
			sw.slideTo(i)
		})
	})

	const sw = new Swiper(swiper, {
		direction: 'horizontal',
		slidesPerView: 1.5,
		spaceBetween: 8,

		mousewheel: {
			forceToAxis: true,
			sensitivity: 0.6
		},
		on: {
			slideChange: (swiper) => {
				const idx = swiper.activeIndex
				const prev = qs('[data-detail-text].active')
				prev.classList.remove('active')
				detailsText[idx].classList.add('active')
			}
		}
	})
})

const productSoldOutBtn = qs('#product-btn-sold')

if (productSoldOutBtn) {
	productSoldOutBtn.addEventListener('click', (e) => {
		e.preventDefault()
	})
}

var lightboxThumbnailSwiper = new Swiper('#lightboxThumbnailSwiper', {
	direction: 'horizontal',
	slidesPerView: 4,
	spaceBetween: 8,
	loop: true,
	spaceBetween: 8,
	watchSlidesProgress: true
})

var lightboxSwiper = new Swiper('#lightboxSwiper', {
	slidesPerView: 1,
	centeredSlides: true,
	loop: true,
	thumbs: {
		swiper: lightboxThumbnailSwiper
	},
	pagination: {
		el: '#lightboxPagination',
		type: 'fraction'
	}
})

const lightboxTrigger = qs('#lightboxTrigger')
const lightbox = qs('#lightbox')
const lightboxClose = qs('#lightboxClose')

if (lightboxTrigger) {
	lightboxTrigger.addEventListener('click', () => {
		lightbox.showModal()
	})

	lightboxClose.addEventListener('click', () => {
		lightbox.close()
	})
}

const footer = document.querySelector('footer')
const hero = document.querySelector('#accordionHero')

if (hero) {
	enterView({
		selector: 'footer',
		enter: function (el) {
			hero.classList.add('invisible')
		},
		exit: function (el) {
			hero.classList.remove('invisible')
		},
		offset: 0.6
	})
}
const fromInput = document.querySelector('#fromFilter')
const toInput = document.querySelector('#toFilter')

if (fromInput && toInput) {
	let timer = null
	let fromValue = sessionStorage.getItem('fromValue')
	let toValue = sessionStorage.getItem('toValue')

	if (fromValue) {
		fromInput.value = fromValue
		toInput.value = toValue
		fromInput.value = fromValue
		toInput.value = toValue
	}

	function changeParams() {
		sessionStorage.setItem('fromValue', fromInput.value)
		sessionStorage.setItem('toValue', toInput.value)

		let searchParams = 'filter.v.price.gte'
		history.pushState(
			{
				searchParams
			},
			'',
			`${window.location.pathname}${
				searchParams &&
				'?'.concat(
					searchParams +
						'=' +
						fromInput.value +
						'&filter.v.price.lte=' +
						toInput.value
				)
			}`
		)
		location.replace(window.location.href)
	}

	fromInput.oninput = function () {
		if (timer) {
			clearTimeout(timer)
			timer = null
		}

		timer = setTimeout(function () {
			changeParams()
			clearTimeout(timer)
			timer = null
		}, 1000)
	}

	toInput.oninput = function () {
		if (timer) {
			clearTimeout(timer)
			timer = null
		}

		timer = setTimeout(function () {
			changeParams()
			clearTimeout(timer)
			timer = null
		}, 1000)
	}
}

//mute toggles

const muteToggleContainers = qsa('[data-mute-toggle-container]')
const muteSvg = `
<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
  <path d="M6 0.666667L4.60667 2.06L6 3.45333V0.666667ZM0.846667 0L0 0.846667L3.15333 4H0V8H2.66667L6 11.3333V6.84667L8.83333 9.68667C8.38667 10.0267 7.88667 10.3067 7.33333 10.4667V11.8467C8.25333 11.6333 9.08667 11.2133 9.78667 10.64L11.1533 12L12 11.1533L6 5.15333L0.846667 0ZM10.6667 6C10.6667 6.62667 10.5333 7.21333 10.3067 7.76L11.3133 8.76667C11.7467 7.94 12 7 12 6C12 3.14667 10 0.76 7.33333 0.153333V1.52667C9.26 2.1 10.6667 3.88667 10.6667 6ZM9 6C9 4.82 8.33333 3.80667 7.33333 3.31333V4.78667L8.96667 6.42C9 6.28667 9 6.14 9 6Z" fill="white"/>
</svg>`
const volumeSvg = `
<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
  <path d="M7.33333 0V1.40935C9.26 1.99772 10.6667 3.83124 10.6667 6C10.6667 8.16876 9.26 9.99544 7.33333 10.5838V12C10 11.3774 12 8.92816 12 6C12 3.07184 10 0.622577 7.33333 0ZM9 6C9 4.78905 8.33333 3.74914 7.33333 3.24287V8.7366C8.33333 8.25086 9 7.2041 9 6ZM0 3.94755V8.05245H2.66667L6 11.4732V0.526796L2.66667 3.94755H0Z" fill="white"/>
</svg>`

muteToggleContainers.forEach((container) => {
	const btn = qs('[data-mute-toggle]', container)
	const video = qs('video', container)

	btn.addEventListener('click', (e) => {
		e.preventDefault()
		if (video.muted) {
			btn.innerHTML = volumeSvg
		} else {
			btn.innerHTML = muteSvg
		}
		video.muted = !video.muted
	})
})
